import { StateParams, StateService } from '@uirouter/core';
import * as angular from 'angular';
import moment = require('moment');

import { ngStorage } from 'ngstorage';
import { ViewportController } from '../../../../../app.common/modules/common/controllers/viewport-typed.controller';
import { IPopupSettings } from '../../../../../app.common/modules/common/models';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { PopupService } from '../../../../../app.common/modules/common/services/popup.service';
import { RetailerService } from '../../../api/retailer.service';
import { ICampaignProductLink } from '../../../campaigns/models';
import { IRetailerRootScope } from '../../../core/models';
import { ProductsService } from '../../../products/products.service';
import { MenuService } from '../../menu.service';
import { IMenuItem, IMenuProduct, IMenuSchedule } from '../../models';
import { ScheduleService } from '../../schedule.service';

class MenuEditorController extends ViewportController {
    public static $inject = [
        '$localStorage',
        'notificationService',
        'popupService',
        'retailerService',
        'productsService',
        'menuService',
        'scheduleService',
        '$rootScope',
        '$scope',
        '$stateParams',
        '$uibModal',
        '$translate',
        '$state',
    ];
    public countryID: number;
    public htmlTooltip = this.$translate.instant('tooltip_menu_products');

    public treeOptions = {
        accept(sourceNodeScope: any, destNodesScope: any) {
            return sourceNodeScope.$modelValue.ItemTypeID === destNodesScope.$modelValue[0].ItemTypeID ? true : false;
        },
        dragStart(event: any) {
            event.elements.dragging[0].classList.add('drag-item');
        },
        dropped(event: any) {
            event.elements.dragging[0].classList.remove('drag-item');
        }
      };

    private NameMaxLength: number = 64;
    private daysToTranslate = [
        'sunday',
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday'
    ];

    private waiting = false;
    private item: IMenuItem = {
        Name: '',
        PredeterminedSorting: false,
        DisplayInApp: false,
        ID: null,
        ImageID: null,
        StartDate: null,
        EndDate: null,
        StartTime: null,
        EndTime: null,
        DaysOfWeek: 0,
        Places: [],
        Products: []
    } as IMenuItem;
    private readonly idParam: string;
    private readonly isDuplicating = false;
    private checkboxes = {
        startTime: true,
        endTime: true,
        endDate: true,

        disable() {
            this.startTime = false;
            this.endTime = false;
            this.endDate = false;
        }
    };
    private schedule: IMenuSchedule;

    private errors = {
        title: '',
        startDate: '',
        days: '',
        endDate: '',
        startTime: '',
        endTime: '',
        clear() {
            this.startDate = '';
            this.title = '';
            this.days = '';
            this.endDate = '';
            this.startTime = '';
            this.endTime = '';
        },
        any() {
            return (
                this.endTime !== '' ||
                this.startTime !== '' ||
                this.startDate !== '' ||
                this.endDate !== '' ||
                this.title !== '' ||
                this.days !== ''
            );
        }
    };
    private dateOptions = {
        formatYear: 'yyyy',
        startingDay: 0,
        minDate: new Date()
    };

    constructor(
        private $localStorage: ngStorage.StorageService,
        private notificationService: NotificationService,
        private popupService: PopupService,
        private retailerService: RetailerService,
        private productsService: ProductsService,
        private menuService: MenuService,
        private scheduleService: ScheduleService,
        $rootScope: IRetailerRootScope,
        private $scope: angular.IScope,
        $stateParams: StateParams,
        private $uibModal: ng.ui.bootstrap.IModalService,
        private $translate: angular.translate.ITranslateService,
        private $state: StateService,
    ) {
        super($rootScope);
        this.idParam = $stateParams.id;
        this.isDuplicating = $stateParams.duplicate;

        $scope.$watch(
            'vm.checkboxes.startTime',
            (changes: any) => {
                if (this.schedule == null) {
                    return;
                }

                if (!this.checkboxes.startTime) {
                    this.checkboxes.endTime = false;
                }

                this.schedule.startTime = !this.checkboxes.startTime
                    ? null
                    : new Date();
            },
            true
        );

        $scope.$watch(
            'vm.checkboxes.endTime',
            (changes: any) => {
                if (this.schedule == null) {
                    return;
                }
                this.schedule.endTime = !this.checkboxes.endTime
                    ? null
                    : new Date();
            },
            true
        );

        $scope.$watch(
            'vm.checkboxes.endDate',
            (changes: any, old: any) => {
                if (this.schedule == null) {
                    return;
                }
                this.schedule.endDate = !this.checkboxes.endDate
                    ? null
                    : new Date();
            },
            true
        );

        $scope.$watch(
            'vm.item.Products',
            () => {
                if (this.item == null) {
                    return;
                }
                this.item.ProductsGroups = this.item.Products.reduce(
                    (groups, item) => {
                        const val = item.ItemTypeName ? item.ItemTypeName : '';
                        groups[val] = groups[val] || [];
                        groups[val].push(item);
                        return groups;
                    },
                    {}
                );
            },
            true
        );

        if (!this.idParam && !this.isDuplicating) {
            this.schedule = this.scheduleService.getFromMenuItem(this.item);
            this.checkboxes.disable();
            this.schedule.setDays(true);
            this.schedule.startDate = new Date();
        } else {
            this.getData();
        }
    }

    public $onInit() {
        this.countryID = this.$localStorage.retailerAuthorizationData.countryID;
    }

    public setUsersOrder(value: boolean) {
        this.item.PredeterminedSorting = !value;
    }

    private getImage(item: IMenuItem) {
        return this.menuService.getMenuImageUrl(
            item.ImageID.toString(),
            142,
            142
        );
    }

    private isAllFilled() {
        return (
            this.item.Name !== '' &&
            this.item.Name.length <= this.NameMaxLength &&
            // Places
            this.item.Places.length > 0 &&
            // Products
            this.item.Products.length > 0 &&
            // Dates
            this.schedule.startDate !== null &&
            // Time
            (!this.checkboxes.startTime ||
                moment(this.schedule.startTime).isValid()) &&
            (!this.checkboxes.endTime ||
                moment(this.schedule.endTime).isValid()) &&
            // Days
            this.schedule.anyDays()
        );
    }

    private async getData() {
        this.notificationService.showWaitingMessage();
        this.waiting = true;
        try {
            this.item = await this.menuService.getMenu(this.idParam);

            this.checkboxes.startTime = this.item.StartTime != null;
            this.checkboxes.endTime = this.item.EndTime != null;
            this.checkboxes.endDate = this.item.EndDate != null;

            this.updateProductModels();
            this.schedule = this.scheduleService.getFromMenuItem(this.item);

            if (this.isDuplicating) {
                this.item.ImageID = null;
                this.item.ID = null;
                this.item.DisplayInApp = false;
            }
            this.notificationService.clearAll();
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
        this.waiting = false;
    }

    private updateProductModels() {
        if (!this.item.Products) {
            this.item.Products = [];
        }

        this.item.Products.forEach((element) => {
            element.MinPrice = element.Variants.reduce(
                (prev, cur) => (cur.Price < prev ? cur.Price : prev),
                element.Variants[0].Price
            );
            element.MaxPrice = element.Variants.reduce(
                (prev, cur) => (cur.Price > prev ? cur.Price : prev),
                element.Variants[0].Price
            );
            element.ImageID = this.retailerService.getProductImageUrl(
                element.Variants[0].ImageIDs[0],
                null,
                64
            );
            element.IsArchived = !element.Variants.some((x) => !x.IsArchived);
        });
    }

    private getPreparedData(): IMenuItem {
        const i = angular.copy(this.item);

        if ((i.EndTime as any) instanceof Date) {
            i.EndTime = (i.EndTime as any).toLocaleTimeString();
        }

        if ((i.StartTime as any) instanceof Date) {
            i.StartTime = (i.StartTime as any).toLocaleTimeString();
        }

        i.PlaceIDs = i.Places.map((x) => x.ID);

        i.ProductIDs = Object.keys(i.ProductsGroups).reduce((accumulator, key) => {
            return accumulator.concat(i.ProductsGroups[key].map((product) => product.productId ? product.productId : product.ID));
        }, []);

        if (i.ImageID < 1) {
            i.ImageID = null;
        }

        i.Products = undefined;
        i.Places = undefined;
        this.scheduleService.updateMenuItemSchedule(this.schedule, i);

        return i;
    }

    private validate(): boolean {
        this.errors.clear();

        if (!moment(this.schedule.startDate).isValid()) {
            this.errors.startDate = this.$translate.instant('invalid_date');
        }

        if (
            this.checkboxes.endDate &&
            (!moment(this.schedule.endDate).isValid() ||
                this.schedule.endDate == null)
        ) {
            this.errors.endDate = this.$translate.instant('invalid_date');
        }

        if (moment(this.schedule.startDate) > moment(this.schedule.endDate)) {
            this.errors.endDate = this.$translate.instant('invalid_end_date');
        }

        if (moment(this.schedule.startTime) > moment(this.schedule.endTime)) {
            this.errors.endTime = this.$translate.instant('invalid_end_time');
        }

        return !this.errors.any();
    }

    private async saveData() {
        if (!this.validate()) {
            return;
        }

        const prepared = this.getPreparedData();
        this.notificationService.showWaitingMessage();
        this.waiting = true;
        try {
            await this.menuService.saveMenu(prepared);
            this.notificationService.clearAll();
            this.notificationService.showSuccessMessage();
            this.$state.go('app.menus', { archived: this.item.IsArchived });
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
        this.waiting = false;
    }

    private async setArchivedMenu(value: boolean) {
        try {
            await this.popupService.confirm({
                okTxt: this.$translate.instant('cancel'),
                okClass: 'btn btn-with-background-icon close-icon--tiny24',
                cancelTxt: this.$translate.instant('archive_menu'),
                cancelClass:
                    'btn btn-with-background-icon icon-trashcan-outline-white btn-danger',
                title: this.$translate.instant('archive_menu_title'),
                content: this.$translate.instant('archive_menu_prompt'),
                invertAction: true,
                classPopup: 'popup--redesign'
            } as IPopupSettings);
        } catch (error) {
            return;
        }

        this.notificationService.showWaitingMessage();
        this.waiting = true;
        try {
            await this.menuService.setArchivedMenu(this.idParam, value);
            this.notificationService.clearAll();
            this.notificationService.showSuccessMessage();
            this.$state.go('app.menus');
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
        this.waiting = false;
    }

    private async addLocations() {
        try {
            this.item.Places = ((await this.$uibModal.open({
                component: 'selectLocations',
                resolve: {
                    options: () => {
                        return {
                            fullName: true,
                            selectedLocations: this.item.Places
                        };
                    }
                },
                backdrop: 'static'
            }).result) as any).selectedLocations;
        } catch (error) {
            return;
        }
    }

    private async addProducts() {
        try {
            const products: any[] = await this.$uibModal.open({
                component: 'productSearch',
                resolve: {
                    categories: () => 228 /* CATEGORY_FOOD_ROOT_ID */,
                    items: () =>
                        this.item.Products.map(
                            (x) =>
                                ({
                                    productId: x.ID,
                                    currencySign: x.CurrencySign,
                                    imageUrl: x.ImageID,
                                    isSelected: true,
                                    title: x.Title,
                                    maxPrice: x.MaxPrice,
                                    minPrice: x.MinPrice,
                                    variants: x.Variants,
                                    itemTypeName: x.ItemTypeName,
                                    itemTypeID: x.ItemTypeID
                                } as ICampaignProductLink)
                        )
                },
                backdrop: 'static'
            }).result;

            this.item.Products = products.map(
                (x) =>
                    ({
                        ID: x.productId,
                        Title: x.title,
                        ImageID: x.imageUrl,
                        MinPrice: x.minPrice,
                        MaxPrice: x.maxPrice,
                        IsArchived: false,
                        Variants: x.variants,
                        ItemTypeName: x.itemTypeName,
                        ItemTypeID: x.itemTypeID,
                        CurrencySign: x.currencySign
                    } as IMenuProduct)
                );
        } catch (error) {
            return;
        }
    }

    private async addImage() {
        try {
            const image = await this.$uibModal.open({
                component: 'jispPayAvatar',
                scope: this.$scope.$new(true),
                resolve: {
                    avatarId: () => this.item.ImageID,
                    title: () => this.$translate.instant('menu_photo'),
                    getUrl: () =>
                        this.item.ImageID == null ||
                        this.menuService.getMenuImageUrl(
                            this.item.ImageID.toString()
                        ),
                    saveUrl: () => this.menuService.saveMenuImageUrl()
                },
                backdrop: 'static'
            }).result;

            if (image) {
                this.item.ImageID = image;
            }
        } catch (error) {
            return;
        }
    }

    private async removeLocation(locationID: number) {
        try {
            await this.popupService.confirm({
                okTxt: this.$translate.instant('cancel'),
                okClass: 'btn btn-with-background-icon close-icon--tiny24',
                cancelTxt: this.$translate.instant('delete'),
                cancelClass:
                    'btn btn-with-background-icon icon-trashcan-outline-white btn-danger',
                title: this.$translate.instant('remove_location'),
                content: this.$translate.instant('remove_location_from_menu'),
                invertAction: true,
                classPopup: 'popup--redesign'
            } as IPopupSettings);
            this.item.Places = this.item.Places.filter(
                (x) => x.ID !== locationID
            );
        } catch (error) {
            console.log('remove place', error);
        }
    }

    private async removeProduct(productID: string) {
        try {
            await this.popupService.confirm({
                okTxt: this.$translate.instant('cancel'),
                okClass: 'btn btn-with-background-icon close-icon--tiny24',
                cancelTxt: this.$translate.instant('delete'),
                cancelClass:
                    'btn btn-with-background-icon icon-trashcan-outline-white btn-danger',
                title: this.$translate.instant('remove_product'),
                content: this.$translate.instant('remove_product_from_menu'),
                invertAction: true,
                classPopup: 'popup--redesign'
            } as IPopupSettings);
            this.item.Products = this.item.Products.filter(
                (x) => x.ID !== productID
            );
        } catch (error) {
            console.log('remove product', error);
        }
    }

    private async cancel() {
        try {
            await this.popupService.confirm({
                okTxt: this.$translate.instant('cancel'),
                okClass: 'btn btn-with-background-icon close-icon--tiny24',
                cancelTxt: this.$translate.instant('discard'),
                cancelClass:
                    'btn btn-with-background-icon icon-undo btn-danger',
                title: this.$translate.instant('discard_changes_title'),
                content: this.$translate.instant('discard_changes'),
                invertAction: true,
                classPopup: 'popup--redesign modal360'
            } as IPopupSettings);
            this.$state.go('app.menus');
        } catch (error) {
            console.log('cancel');
        }
    }
}

angular.module('naut').component('menu.editor', {
    template: require('./menu.editor.html'),
    controller: MenuEditorController,
    controllerAs: 'vm'
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/menus/components/menu-editor/menu.editor.component.ts